module.exports = __webpack_public_path__ + "img/disco-logo.1b8eef4e.jpg";